import type { HTMLComponent } from "@commercekit/react";
import type { ImageField } from "@prismicio/client";
import { asImageSrc, asImageWidthSrcSet } from "@prismicio/helpers";

// Same compression as prod (Prismic default); fit=max never upscales originals smaller than the requested width
const imgixParams = {
  auto: ["format" as const, "compress" as const],
  fit: "max" as const,
};

const WvBlogPageBanner: HTMLComponent<{
  image?: ImageField;
  wovar: string;
  blog: string;
  subtitle: string;
}> = ({
  image,
  wovar,
  blog,
  subtitle,
}) => {
  return (
    <section className="news-header mb-3">
      <div className="img img__absolute">
        <img
          src={asImageSrc(image, { ...imgixParams, w: 1200 }) || ""}
          srcSet={
            asImageWidthSrcSet(image, {
              ...imgixParams,
              widths: [640, 828, 1200, 1600, 2048, 2760],
            })?.srcset
          }
          sizes="(min-width: 1400px) 1380px, 100vw"
          alt={image?.alt || ""}
        />
      </div>
      <div className="container py-4 py-lg-5 d-flex flex-column justify-content-center align-items-center">
        <h1 className="heading sans-serif lg inverted mb-0">
          <strong>{wovar}</strong> {blog}
        </h1>
        <p>{subtitle}</p>
      </div>
    </section>
  );
};
export default WvBlogPageBanner;
